import axios, { AxiosError } from 'axios';
import axiosRetry from 'axios-retry';

const AXIOS_RETRY_NUMBER = Number(window.globalConfiguration.axios.retryNumber ?? 3);
const AXIOS_RETRY_DELAY = Number(window.globalConfiguration.axios.retryDelay ?? 2000);

axiosRetry(axios, {
  retries: AXIOS_RETRY_NUMBER,
  retryDelay: () => {
    return AXIOS_RETRY_DELAY; // time interval between retries
  },
  retryCondition: (error: AxiosError) => {
    const retryStatus = [403, 503];

    if (typeof error === 'undefined' || typeof error.response === 'undefined') {
      return true;
    }

    return retryStatus.includes(error.response.status);
  },
});
